export default{
  template: "#vue-accordion",
  delimiters: ['${', '}'],
  data: function () {
    return {
      active_tab: null
    }
  },
  methods: {
    activateTab: function(tab_index, tab_name) {
      dataLayer.push({"event":"view_faq", "tab_name": tab_name})
      this.active_tab = parseInt(tab_index);
    }
  }
}